import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppSettingsPage.';
  public static readonly franchiseeTitle = `${Id.prefix}franchiseeTitle`;
  public static readonly franchiseeSettingsPageDescription = `${Id.prefix}franchiseeSettingsPageDescription`;
}

export class LangAppSettingsPage {
  private constructor() {}
  public static franchiseeTitle(): string {
    return interpolate(Id.franchiseeTitle);
  }
  public static franchiseeSettingsPageDescription(): string {
    return interpolate(Id.franchiseeSettingsPageDescription);
  }
}

export class AppSettingsPageModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.franchiseeTitle, "{{glossary 'franchisee'}}", 'Title for the franchisee settings page');
    register.add(
      Id.franchiseeSettingsPageDescription,
      "{{glossary 'franchisee'}} settings page",
      'Description for the franchisee settings page'
    );
  }
}
